import { type Locale, getLocale, localeReady, setLocale } from "@quickpoint.me/shared";
import { atom } from "recoil";

export const LocaleAtom = atom<Locale>({
	key: "Locale",
	// Promise default: subscribers suspend until the startup locale's
	// translation table is loaded (resolves immediately for English), so
	// non-English users never see an untranslated first render.
	default: localeReady.then(() => getLocale()),
	effects: [
		({ onSet }) => {
			onSet((newLocale) => {
				// Callers that need the new translations before re-rendering
				// (e.g. TopBar) await setLocale themselves before setting the atom;
				// this covers any path that sets the atom directly.
				void setLocale(newLocale);
			});
		},
	],
});
